<template>
	<div class="shoplist">
		<div class="xx">
			<div class="name">
				{{qd.name}}
			</div>
			<div class="xitem">
				<div class="t_v">
					<div class="t">配货率</div>
					<div :class="qd.allocation_rate >= 86?'v green':'v red'">{{qd.allocation_rate}}%</div>
				</div>

				<div class="t_v">
					<div class="t">发货率</div>
					<div :class="qd.on_time_rate >= 86?'v green':'v red'">{{qd.on_time_rate}}%</div>
				</div>

				<div class="t_v">
					<div class="t">免费退货比例</div>
					<div :class="qd.free_return_rate >= 86?'v green':'v red'">{{qd.free_return_rate}}%</div>
				</div>

				<div class="t_v">
					<div class="t">超出扣费</div>
					<div class="v">{{qd.exceed_rate_deduct}}%</div>
				</div>
			</div>
		</div>
		<div class="sx">
			<el-form :inline="true" :model="formfilter" size="small" label-width="0px">
				<el-form-item label="">
					<el-input v-model="formfilter.brand" placeholder="品牌" style="width: 140px"></el-input>
				</el-form-item>
				<el-form-item label="">
					<el-select v-model="formfilter.cid_first" placeholder="大类" clearable style="width: 100px">
						<el-option label="大类" value=""></el-option>
						<el-option label="鞋" value="鞋"></el-option>
						<el-option label="服装" value="服装"></el-option>
						<el-option label="配件" value="配件"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-input v-model="formfilter.season" placeholder="季度" style="width: 100px"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onfilter">查询</el-button>
					<el-button @click="onbdiscount(2)">按销量倒序</el-button>
					<el-button @click="onbdiscount(4)">最低折扣</el-button>
					<el-button @click="onbdiscount(5)">最新商品</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="list">
			<div class="item" v-for="(x,y) in list" :key="y" @click="ondetail(x.id)">
				<img class="img" :src="onimgarr(x.pic)[0]" v-if="onimgarr(x.pic)[0]">
				<img class="img" v-else src="../../assets/image/null.png">
				<p class="p1">{{x.brand}} {{x.sex}} {{x.cid_second}} {{x.cid_third}} {{x.style_number}}</p>
				<p class="p2">会员价<span>￥{{x.discount_price}}</span>起</p>
				<div class="zkbq">
					<div class="n">{{x.discount_str}}</div>
					<div>折起</div>
				</div>
			</div>
		</div>
		
		<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
			:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
			@current-change="handleCurrentChange" @size-change="handleSizeChange">
		</el-pagination>
		
	</div>
</template>

<script>
	export default {
		name: 'shoplist',
		data() {
			return {
				page: 1,
				pageSize: 20,
				total: 0,
				list: [],
				id: '',
				code: "",
				qd: {},
				formfilter: {
					keyword: "",
					brand: "",
					cid_first: "",
					season: "",
					order_type: "",
				}
			}
		},

		mounted() {
			console.log(this.appdata.product_category_list);
			this.id = this.$route.query.id;
			this.code = this.$route.query.code;
			this.onlist();
			this.oninfo();
		},
		
		inject: ['onimgarr','appdata'],

		methods: {
			handleCurrentChange() {
				this.onlist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.shop_id = this.id;
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/product/list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					}
				}).catch(err => {
					console.log(err)
				})
			},

			oninfo() {
				var obj = {
					id: this.id
				};
				obj.page = 1;
				obj.limit = 10;
				this.$axios.post('api/product/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qd = res.data.data.list[0];
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onbdiscount(n) {
				this.formfilter.order_type = n;
				this.onfilter();
			},
			
			ondetail(val) {
				const url = this.$router.resolve({
					path: '/detail',
					query: {
						id: val
					}
				});
				window.open(url.href, "_blank");
			},
		}
	}
</script>

<style scoped lang="less">
	.shoplist {
		height: 100%;
	}

	.xx {
		width: 100%;
		height: 100px;
		background: #fffcfc;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		.name {
			width: 25%;
			text-align: center;
			font-size: 20px;
			font-weight: bold;
		}

		.xitem {
			display: flex;
			align-items: center;
			width: 75%;

			.t_v {
				width: 25%;
				text-align: center;
				.t {
					font-size: 16px;
					font-weight: 900;
					color: #111;
				}

				.v {
					margin-top: 10px;
					font-size: 14px;
					font-weight: 500;
					color: #999;
				}
			}
		}
	}
	
	.sx {
		width: 100%;
		padding: 0 10px;
		box-sizing: border-box;
	}
	
	.list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		padding: 0 10px;
		box-sizing: border-box;
		margin-bottom: 20px;
		.item {
			width: calc(20% - 12px);
			padding: 4px;
			box-sizing: border-box;
			border-radius: 12px;
			border: 1px solid transparent;
			margin-right: 12px;
			cursor: pointer;
			position: relative;
			margin-bottom: 12px;
			.img {
				width: 100%;
				border-radius: 10px;
			}
		
			p {
				color: #333;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
		
			}
		
			.p1 {
				font-weight: bold;
			}
		
			.p2 {
				span {
					color: #F65730;
					font-size: 16px;
				}
			}
		
			.zkbq {
				width: 38px;
				height: 58px;
				background-image: url(../../assets/image/zkbq.png);
				background-size: 100%;
				background-repeat: no-repeat;
				position: absolute;
				top: 0;
				left: 10px;
				z-index: 9;
				color: #fff;
				text-align: center;
				padding-top: 2px;
				display: flex;
				flex-direction: column;
				.n {
					font-size: 14px;
				}
			}
		}
		
		.item:nth-child(5n) {
			margin-right: 0;
		}
		
		.item:hover {
			border: 1px solid #F65730;
		}
	}

	.green {
		color: green !important;
	}

	.red {
		color: red !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/shoplist.vue